import React, { useState } from 'react';
import { DataTable } from '../components/DataTable';
import { WizardForm } from '../components/WizardForm';
import { StatusBadge } from '../components/StatusBadge';
export function ForestCompliance() {
  const [activeTab, setActiveTab] = useState<'cases' | 'file' | 'blacklist'>('cases');
  const [currentStep, setCurrentStep] = useState(0);
  const cases = [{
    caseId: 'CASE-2024-001',
    offender: 'Unknown Person',
    offense: 'Illegal Entry',
    date: '2024-03-28',
    location: 'Chandpai Range',
    status: 'open' as const,
    severity: 'High'
  }, {
    caseId: 'CASE-2024-002',
    offender: 'Habib Mollah',
    offense: 'Poaching',
    date: '2024-03-25',
    location: 'Katka Station',
    status: 'resolved' as const,
    severity: 'Critical'
  }, {
    caseId: 'CASE-2024-003',
    offender: 'Nur Islam',
    offense: 'Overharvesting',
    date: '2024-03-20',
    location: 'Sarankhola Range',
    status: 'escalated' as const,
    severity: 'Medium'
  }, {
    caseId: 'CASE-2024-004',
    offender: 'Kamal Uddin',
    offense: 'Unauthorized Vessel',
    date: '2024-03-15',
    location: 'Dhangmari Station',
    status: 'open' as const,
    severity: 'Low'
  }];
  const blacklist = [{
    name: 'Habib Mollah',
    nid: '7890123456789',
    reason: 'Repeated Poaching Offenses',
    blacklistedDate: '2024-03-25',
    duration: '2 years',
    caseRef: 'CASE-2024-002'
  }, {
    name: 'Karim Talukdar',
    nid: '8901234567890',
    reason: 'Illegal Timber Trade',
    blacklistedDate: '2024-02-10',
    duration: '5 years',
    caseRef: 'CASE-2024-015'
  }];
  const caseColumns = [{
    key: 'caseId',
    label: 'Case ID'
  }, {
    key: 'offender',
    label: 'Offender Name'
  }, {
    key: 'offense',
    label: 'Offense Type'
  }, {
    key: 'date',
    label: 'Date'
  }, {
    key: 'location',
    label: 'Location/Zone'
  }, {
    key: 'status',
    label: 'Status',
    render: (value: string) => <StatusBadge status={value as any} data-id="element-700" />
  }, {
    key: 'severity',
    label: 'Severity'
  }];
  const blacklistColumns = [{
    key: 'name',
    label: 'Name'
  }, {
    key: 'nid',
    label: 'NID'
  }, {
    key: 'reason',
    label: 'Reason'
  }, {
    key: 'blacklistedDate',
    label: 'Blacklisted Date'
  }, {
    key: 'duration',
    label: 'Duration'
  }, {
    key: 'caseRef',
    label: 'Case Reference'
  }];
  const caseFilters = [{
    key: 'offense',
    label: 'Offense Type',
    options: ['Illegal Entry', 'Poaching', 'Overharvesting', 'Unauthorized Vessel']
  }, {
    key: 'status',
    label: 'Status',
    options: ['Open', 'Resolved', 'Escalated']
  }, {
    key: 'severity',
    label: 'Severity',
    options: ['Low', 'Medium', 'High', 'Critical']
  }];
  const wizardSteps = [{
    title: 'Offender Info',
    description: 'Identify the offender'
  }, {
    title: 'Offense Details',
    description: 'Enter offense information'
  }, {
    title: 'Action Taken',
    description: 'Record actions and penalties'
  }, {
    title: 'Review & Submit',
    description: 'Review all information before submitting'
  }];
  return <div className="space-y-6" data-id="element-701">
      <div data-id="element-702">
        <h1 className="text-2xl font-bold text-gray-900" data-id="element-703">
          Forest Case & Compliance
        </h1>
        <p className="text-sm text-gray-600 mt-1" data-id="element-704">
          Track offenses and manage blacklist
        </p>
      </div>

      {/* Tabs */}
      <div className="border-b border-gray-200" data-id="element-705">
        <div className="flex gap-4" data-id="element-706">
          <button onClick={() => setActiveTab('cases')} className={`px-4 py-2 border-b-2 font-medium text-sm transition-colors ${activeTab === 'cases' ? 'border-[#1B5E20] text-[#1B5E20]' : 'border-transparent text-gray-600 hover:text-gray-900'}`} data-id="element-707">
            Case Registry
          </button>
          <button onClick={() => setActiveTab('file')} className={`px-4 py-2 border-b-2 font-medium text-sm transition-colors ${activeTab === 'file' ? 'border-[#1B5E20] text-[#1B5E20]' : 'border-transparent text-gray-600 hover:text-gray-900'}`} data-id="element-708">
            File New Case
          </button>
          <button onClick={() => setActiveTab('blacklist')} className={`px-4 py-2 border-b-2 font-medium text-sm transition-colors ${activeTab === 'blacklist' ? 'border-[#1B5E20] text-[#1B5E20]' : 'border-transparent text-gray-600 hover:text-gray-900'}`} data-id="element-709">
            Blacklist ({blacklist.length})
          </button>
        </div>
      </div>

      {/* Content */}
      {activeTab === 'cases' && <DataTable columns={caseColumns} data={cases} filters={caseFilters} onView={row => console.log('View', row)} onEdit={row => console.log('Edit', row)} searchPlaceholder="Search cases..." data-id="element-710" />}

      {activeTab === 'file' && <WizardForm steps={wizardSteps} currentStep={currentStep} onStepChange={setCurrentStep} onSubmit={() => {
      alert('Case filed successfully!');
      setCurrentStep(0);
      setActiveTab('cases');
    }} data-id="element-711">
          {currentStep === 0 && <div className="space-y-4" data-id="element-712">
              <div data-id="element-713">
                <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-714">
                  Search Beneficiary
                </label>
                <input type="text" placeholder="Enter NID or Name (leave empty if unknown)" className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#1B5E20]" data-id="element-715" />
              </div>
              <div className="text-center text-sm text-gray-600 py-2" data-id="element-716">
                OR Enter Unknown Person Details
              </div>
              <div className="space-y-4" data-id="element-717">
                <div data-id="element-718">
                  <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-719">
                    Name (if known)
                  </label>
                  <input type="text" className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#1B5E20]" data-id="element-720" />
                </div>
                <div data-id="element-721">
                  <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-722">
                    Description
                  </label>
                  <textarea rows={3} placeholder="Physical description, clothing, etc." className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#1B5E20]" data-id="element-723"></textarea>
                </div>
              </div>
            </div>}
          {currentStep === 1 && <div className="space-y-4" data-id="element-724">
              <div data-id="element-725">
                <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-726">
                  Offense Type *
                </label>
                <select className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#1B5E20]" data-id="element-727">
                  <option value="" data-id="element-728">Select Offense</option>
                  <option value="illegal-entry" data-id="element-729">Illegal Entry</option>
                  <option value="poaching" data-id="element-730">Poaching</option>
                  <option value="overharvesting" data-id="element-731">Overharvesting</option>
                  <option value="unauthorized-vessel" data-id="element-732">
                    Unauthorized Vessel
                  </option>
                </select>
              </div>
              <div className="grid grid-cols-2 gap-4" data-id="element-733">
                <div data-id="element-734">
                  <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-735">
                    Date *
                  </label>
                  <input type="date" className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#1B5E20]" data-id="element-736" />
                </div>
                <div data-id="element-737">
                  <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-738">
                    Time *
                  </label>
                  <input type="time" className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#1B5E20]" data-id="element-739" />
                </div>
              </div>
              <div data-id="element-740">
                <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-741">
                  Location/Zone *
                </label>
                <select className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#1B5E20]" data-id="element-742">
                  <option value="" data-id="element-743">Select Location</option>
                  <option value="chandpai" data-id="element-744">Chandpai Range</option>
                  <option value="katka" data-id="element-745">Katka Station</option>
                  <option value="sarankhola" data-id="element-746">Sarankhola Range</option>
                  <option value="dhangmari" data-id="element-747">Dhangmari Station</option>
                </select>
              </div>
              <div data-id="element-748">
                <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-749">
                  Description *
                </label>
                <textarea rows={4} placeholder="Detailed description of the offense" className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#1B5E20]" data-id="element-750"></textarea>
              </div>
              <div data-id="element-751">
                <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-752">
                  Evidence Upload
                </label>
                <input type="file" multiple accept="image/*,video/*" className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#1B5E20]" data-id="element-753" />
              </div>
            </div>}
          {currentStep === 2 && <div className="space-y-4" data-id="element-754">
              <div data-id="element-755">
                <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-756">
                  Fine Amount (BDT)
                </label>
                <input type="number" placeholder="0" className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#1B5E20]" data-id="element-757" />
              </div>
              <div className="space-y-2" data-id="element-758">
                <label className="flex items-center gap-2" data-id="element-759">
                  <input type="checkbox" className="w-4 h-4 text-[#1B5E20] rounded" data-id="element-760" />
                  <span className="text-sm font-medium text-gray-700" data-id="element-761">
                    Suspend Permit
                  </span>
                </label>
                <label className="flex items-center gap-2" data-id="element-762">
                  <input type="checkbox" className="w-4 h-4 text-[#1B5E20] rounded" data-id="element-763" />
                  <span className="text-sm font-medium text-gray-700" data-id="element-764">
                    Add to Blacklist
                  </span>
                </label>
              </div>
              <div data-id="element-765">
                <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-766">
                  Additional Notes
                </label>
                <textarea rows={4} placeholder="Any additional actions taken or notes" className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#1B5E20]" data-id="element-767"></textarea>
              </div>
            </div>}
          {currentStep === 3 && <div className="space-y-6" data-id="element-768">
              <div className="bg-gray-50 rounded-lg p-4" data-id="element-769">
                <h4 className="font-semibold text-gray-900 mb-3" data-id="element-770">
                  Offender Information
                </h4>
                <div className="text-sm" data-id="element-771">
                  <div data-id="element-772">
                    <span className="text-gray-600" data-id="element-773">Name:</span>{' '}
                    <span className="font-medium" data-id="element-774">Unknown Person</span>
                  </div>
                  <div data-id="element-775">
                    <span className="text-gray-600" data-id="element-776">Description:</span>{' '}
                    <span className="font-medium" data-id="element-777">
                      Male, approximately 30 years old
                    </span>
                  </div>
                </div>
              </div>
              <div className="bg-gray-50 rounded-lg p-4" data-id="element-778">
                <h4 className="font-semibold text-gray-900 mb-3" data-id="element-779">
                  Offense Details
                </h4>
                <div className="grid grid-cols-2 gap-3 text-sm" data-id="element-780">
                  <div data-id="element-781">
                    <span className="text-gray-600" data-id="element-782">Type:</span>{' '}
                    <span className="font-medium" data-id="element-783">Illegal Entry</span>
                  </div>
                  <div data-id="element-784">
                    <span className="text-gray-600" data-id="element-785">Date:</span>{' '}
                    <span className="font-medium" data-id="element-786">2024-03-30 14:30</span>
                  </div>
                  <div data-id="element-787">
                    <span className="text-gray-600" data-id="element-788">Location:</span>{' '}
                    <span className="font-medium" data-id="element-789">Chandpai Range</span>
                  </div>
                </div>
              </div>
              <div className="bg-gray-50 rounded-lg p-4" data-id="element-790">
                <h4 className="font-semibold text-gray-900 mb-3" data-id="element-791">
                  Action Taken
                </h4>
                <div className="text-sm" data-id="element-792">
                  <div data-id="element-793">
                    <span className="text-gray-600" data-id="element-794">Fine:</span>{' '}
                    <span className="font-medium" data-id="element-795">5000 BDT</span>
                  </div>
                  <div data-id="element-796">
                    <span className="text-gray-600" data-id="element-797">Permit Suspended:</span>{' '}
                    <span className="font-medium" data-id="element-798">No</span>
                  </div>
                  <div data-id="element-799">
                    <span className="text-gray-600" data-id="element-800">Blacklisted:</span>{' '}
                    <span className="font-medium" data-id="element-801">No</span>
                  </div>
                </div>
              </div>
            </div>}
        </WizardForm>}

      {activeTab === 'blacklist' && <DataTable columns={blacklistColumns} data={blacklist} onView={row => console.log('View', row)} searchPlaceholder="Search blacklist..." data-id="element-802" />}
    </div>;
}